import Enum from './Enum';

class DepositPaymentStatus extends Enum {
  INIT = 0;

  APPLIED = 1;

  COMPLETED = 2;

  FAIL = 3;

  REFUND_APPLIED = 4;

  REFUND_SUCCESS = 5;

  REFUND_FAIL = 6;

  WAITING_REFUND = 7;

  CHARGEBACK = 8;


  labels() {
    const labels = {};
    labels[this.INIT] = 'Init';
    labels[this.APPLIED] = 'Applied';
    labels[this.COMPLETED] = 'Completed';
    labels[this.FAIL] = 'Fail';
    labels[this.REFUND_APPLIED] = 'Refund Applied';
    labels[this.REFUND_SUCCESS] = 'Refund Success';
    labels[this.REFUND_FAIL] = 'Refund Fail';
    labels[this.WAITING_REFUND] = 'Waiting Refund';
    labels[this.CHARGEBACK] = 'Chargeback';
    return labels;
  }
}

export default new DepositPaymentStatus();
